import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {TraceNodeDto} from "../../model/dto/entity/trace-node.dto";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerCreditService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/bm/customerCredits')
  }

  getCustomerCreditTrace(id: number): Observable<TraceNodeDto> {
    return this.http.get<TraceNodeDto>(`${this.apiUrl}/customerCredits/customer-credit-trace/${id}`);
  }
}